export class BillingAction {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default BillingAction;